import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import CandidateCard from "@/components/candidates/CandidateCard";
import CandidateFilters from "@/components/candidates/CandidateFilters";
import AiSearchBar from "@/components/search/AiSearchBar";
import SEO from "@/components/seo/SEO";
import api from "@/lib/api";

export default function CandidatesListPage() {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({});
  const [candidates, setCandidates] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = { ...filters, page: 1, limit: 20 };
    Object.keys(params).forEach((k) => (params[k] === "" || params[k] == null) && delete params[k]);
    api.get("/profiles/candidates/search", { params }).then(({ data }) => {
      setCandidates(data.items);
      setTotal(data.total);
    }).finally(() => setLoading(false));
  }, [filters]);

  return (
    <div className="max-w-7xl mx-auto px-6 sm:px-8 py-10 sm:py-14" data-testid="candidates-list-page">
      <SEO title="Candidats saisonniers vitivinicoles | JobVinum"
           description="Trouvez des travailleurs saisonniers qualifiés pour les vendanges, la taille et les travaux de vigne en Europe. Profils multilingues vérifiés." path="/candidates" />
      <h1 className="font-heading text-2xl sm:text-3xl font-bold mb-6">{t("search.candidatesTitle")}</h1>
      <AiSearchBar searchType="candidates" onApplyFilters={(f) => setFilters((prev) => ({ ...prev, ...f }))} testIdPrefix="candidates-ai-search" />
      <div className="mb-8">
        <CandidateFilters filters={filters} onChange={setFilters} onReset={() => setFilters({})} />
      </div>

      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-[#4ba3b7]" /></div>
      ) : candidates.length === 0 ? (
        <p className="text-center py-20 text-[#2B2B2B]/50" data-testid="candidates-no-results">{t("search.noResults")}</p>
      ) : (
        <>
          <p className="text-sm text-[#2B2B2B]/50 mb-4">{total} {t("search.resultsCount")}</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {candidates.map((c) => <CandidateCard key={c.user_id} candidate={c} />)}
          </div>
        </>
      )}
    </div>
  );
}
